import { useEffect, useState, useCallback } from 'react';

import { theme } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppSelector } from '@hooks/useSelector/useAppSelector';
import { responseSuccess } from 'helper/responseSuccess/responseSuccess';
import { USER_ROLE_COMPANY, USER_TYPE_IP_SUPPORT } from 'constants/User';
import { getEmailFirebase, getPasswordFirebase } from 'helper/firebase';
import { collection, doc, limit, onSnapshot, query, setDoc, where } from 'firebase/firestore';
import { firestoreFirebaseApp, firestoreFirebaseAuthApp } from '@hooks/useFireBase/useFireBase';
import { apiListCompanyB2BPaired, getCompanyCountChatMessagesNotRead } from 'api/company';
import { useAppDispatch } from '@hooks/useDispatch/useAppDispatch';
import { storeSetCompanyIdLeague } from '@store/auth-reducer';
import { storeSetListCompanyB2BPaired } from '@store/company-reducer';

const useHeaderCompany = () => {
  const navigate = useNavigate();
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  const companyIdLeague = useAppSelector((state) => state.auth.companyIdLeague);

  const location = useLocation();
  const dispatch = useAppDispatch();
  const firestoreFirebase = firestoreFirebaseApp;
  const firestoreFirebaseAuth = firestoreFirebaseAuthApp;
  const authInfo = useAppSelector((state) => state.auth.authInfo);
  const listCompanyB2BPaired = useAppSelector((state) => state.company.listCompanyB2BPaired);

  const [messagesNotRead, setMessagesNotRead] = useState<number>(0);
  const [messagesMysqlNotRead, setMessagesMysqlNotRead] = useState<number>(0);
  const [isHasNewNotify, setIsHasNewNotify] = useState<boolean>(false);
  const [isOpenNoti, setIsOpenNoti] = useState<boolean>(false);
  const [idNotiFireBase, setIdNotiFireBase] = useState<any>();
  const getListCompanyB2BPaired = async () => {
    const response = await apiListCompanyB2BPaired();
    if (responseSuccess(response)) {
      dispatch(storeSetListCompanyB2BPaired(response.data));
    }
  };

  const handleClickChat = () => {
    setMessagesMysqlNotRead(0);
    setMessagesNotRead(0);
    navigate('/chat');
  };

  // const onReadAllNotice = async () => {
  //   try {
  //     await apiReadAllNotifications();
  //   } catch (error) {}
  // };

  const handleClickNotice = () => {
    if (location.pathname === '/setting-page/listNotice') {
      window.location.reload();
    } else {
      navigate('/setting-page/listNotice');
    }
  };

  useEffect(() => {
    if (location.pathname === '/setting-page/listNotice') {
      // setIsHasNewNotify(false);
      // onReadAllNotice();
    }
  }, [location.pathname]);

  // count total mesasge mysql not read
  const getTotalMessageNotRead = async () => {
    const response = await getCompanyCountChatMessagesNotRead();
    if (responseSuccess(response)) {
      setMessagesMysqlNotRead(response.data.count);
    }
  };

  // get messages not read
  const getMessages = useCallback(() => {
    if (!authInfo || !firestoreFirebaseAuth?.currentUser || !firestoreFirebase) return;

    const messagesRef = collection(firestoreFirebase, 'messages');
    const queryGetListMessage = query(messagesRef, where('group_company_id', '==', Number(authInfo?.company?.id)));
    onSnapshot(queryGetListMessage, (messagesSnapshot: any) => {
      let countMessage = 0;
      messagesSnapshot.docs.forEach((doc: any) => {
        const messageData = doc.data();
        const userId =
          Number(authInfo.user.user_type) === USER_TYPE_IP_SUPPORT && authInfo.user.user_root_id
            ? authInfo.user.user_root_id
            : authInfo.user.id;
        if (!messageData.reads?.includes(`${authInfo.user.user_role}.${userId}`)) {
          countMessage++;
        }
      });

      setMessagesNotRead(messagesMysqlNotRead + countMessage);
    });
  }, [authInfo, firestoreFirebase, firestoreFirebaseAuth?.currentUser, messagesMysqlNotRead]);

  useEffect(() => {
    getMessages();

    return () => {
      getMessages();
    };
  }, [getMessages]);

  const getNotifies = useCallback(() => {
    if (!authInfo || !firestoreFirebase) return;

    const notifyRef = collection(firestoreFirebase, 'notifications');
    const userId =
      Number(authInfo.user.user_type) === USER_TYPE_IP_SUPPORT && authInfo.user.user_root_id
        ? authInfo.user.user_root_id
        : authInfo.user.id;

    const queryNotify = query(
      notifyRef,
      where('user_role', '==', USER_ROLE_COMPANY),
      where('user_id', '==', Number(userId)),
      limit(1)
    );
    onSnapshot(queryNotify, (messagesSnapshot: any) => {
      if (messagesSnapshot.docs.length > 0) {
        const notify = messagesSnapshot.docs[0].data();
        if (notify.count > 0) {
          setIsHasNewNotify(true);
        } else {
          setIsHasNewNotify(false);
        }
      } else {
        setIsHasNewNotify(false);
      }
    });
  }, [authInfo, firestoreFirebase]);

  const getNotiInsufficientBalance = useCallback(() => {
    if (!authInfo || !firestoreFirebase) return;
    const notifyRef = collection(firestoreFirebase, 'notify_balance_insufficient');
    const userId =
      Number(authInfo.user.user_type) === USER_TYPE_IP_SUPPORT && authInfo.user.user_root_id
        ? authInfo.user.user_root_id
        : authInfo.user.id;
    const queryNotify = query(
      notifyRef,
      where('user_role', '==', USER_ROLE_COMPANY),
      where('user_id', '==', Number(userId)),
      limit(1)
    );
    onSnapshot(queryNotify, (messagesSnapshot: any) => {
      if (messagesSnapshot.docs.length > 0) {
        const notifyDoc = messagesSnapshot.docs[0];
        const notify = messagesSnapshot.docs[0].data();
        if (notify.count > 0) {
          setIdNotiFireBase(notifyDoc.id);
          setIsOpenNoti(true);
        }
      }
    });
  }, [authInfo, firestoreFirebase]);

  // get new noti
  useEffect(() => {
    getNotifies();

    return () => {
      getNotifies();
    };
  }, [getNotifies]);
  useEffect(() => {
    getNotiInsufficientBalance();
    return () => {
      getNotiInsufficientBalance();
    };
  }, [getNotiInsufficientBalance]);
  // refesh token

  useEffect(() => {
    if (!firestoreFirebaseAuth?.currentUser && authInfo?.user) {
      firestoreFirebaseAuth?.signOut();
      const emailUser = getEmailFirebase(authInfo.user?.email, authInfo.user?.user_role);
      const passwordUser = getPasswordFirebase(authInfo.user?.email, authInfo.user?.user_role);
      if (emailUser && passwordUser) {
        firestoreFirebaseAuth?.signInWithEmailAndPassword(emailUser, passwordUser);
      }
    }
  }, [firestoreFirebaseAuth, authInfo]);

  useEffect(() => {
    getTotalMessageNotRead();
    getListCompanyB2BPaired();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const changeCompanyLeague = (e: number) => {
    dispatch(storeSetCompanyIdLeague(Number(e)));
    setTimeout(() => {
      if (location.pathname === '/') {
        window.location.reload();
      } else {
        navigate('/');
      }
    }, 400);
  };

  const handleConfirmNoti = () => {
    if (!authInfo || !firestoreFirebase) return;
    const notifyRef = doc(firestoreFirebase, 'notify_balance_insufficient', idNotiFireBase);
    setDoc(notifyRef, { count: 0 }, { merge: true });
    setIsOpenNoti(false);
  };

  return {
    handleClickChat,
    navigate,
    authInfo,
    messagesNotRead,
    colorBgContainer,
    isHasNewNotify,
    handleClickNotice,
    listCompanyB2BPaired,
    dispatch,
    companyIdLeague,
    changeCompanyLeague,
    isOpenNoti,
    handleConfirmNoti,
  };
};

export default useHeaderCompany;
